// Mock data for demo purposes
export const mockUsers = {
  staff: [
    {
      id: 'adm001',
      username: 'admin',
      password: '1234',
      name: 'Admin Plataforma',
      role: 'admin',
      email: 'admin@clinic.com',
      phone: '+593 98 100 1000',
      documentId: 'ADM-0001',
      position: 'Administrador del sistema',
      status: 'available',
    },
    {
      id: 'nurse001',
      username: 'enfermeria',
      password: '1234',
      name: 'Lcda. Rosa Castillo',
      role: 'nurse',
      email: 'rosa.castillo@clinic.com',
      phone: '+593 98 100 3001',
      documentId: 'ENF-3001',
      position: 'Enfermeria',
      status: 'available',
    },
    {
      id: 'admission001',
      username: 'admision',
      password: '1234',
      name: 'Andrea Salazar',
      role: 'admission',
      email: 'andrea.salazar@clinic.com',
      phone: '+593 98 100 4001',
      documentId: 'ADMIS-4001',
      position: 'Admision',
      status: 'available',
    },
  ],
  doctors: [
    {
      id: 'doc001',
      username: 'general',
      password: '1234',
      name: 'Dr. Jhon Smit',
      role: 'doctor',
      specialty: 'Medicina General',
      email: 'jhon.smit@clinic.com',
      phone: '+593 98 100 2001',
      documentId: 'DOC-1001',
      status: 'available',
      isOnline: true,
      onDuty: true,
      nextAvailable: 'Ahora',
      photo: '👨‍⚕️',
    },
    {
      id: 'doc002',
      username: 'ginecologia',
      password: '1234',
      name: 'Dra. Ana Morales',
      role: 'doctor',
      specialty: 'Ginecologia',
      email: 'ana.morales@clinic.com',
      phone: '+593 98 100 2002',
      documentId: 'DOC-1002',
      status: 'available',
      isOnline: true,
      onDuty: true,
      nextAvailable: 'Hoy 15:30',
      photo: '👩‍⚕️',
    },
    {
      id: 'doc003',
      username: 'pediatria',
      password: '1234',
      name: 'Dr. Carlos Viteri',
      role: 'doctor',
      specialty: 'Pediatria',
      email: 'carlos.viteri@clinic.com',
      phone: '+593 98 100 2003',
      documentId: 'DOC-1003',
      status: 'available',
      isOnline: false,
      onDuty: true,
      nextAvailable: 'Mañana 09:00',
      photo: '👨‍⚕️',
    },
  ],
  patients: [
    {
      id: 'pat001',
      username: 'lucia',
      password: '1234',
      name: 'Lucía Ramírez',
      role: 'patient',
      documentId: '1712345678',
      clinicalHistoryNumber: 'HCU-0001',
      fileNumber: 'ARCH-001',
      email: 'lucia@clinic.com',
      phone: '+34 612 001 002',
      birthDate: '1990-04-12',
      sex: 'Femenino',
      insurance: 'Plan Premium',
      plan: 'Plan Premium',
      serviceActive: true,
      address: 'Av. Amazonas N34-120, Quito',
      city: 'Quito',
      province: 'Pichincha',
      emergencyContact: 'María Ramírez',
      emergencyPhone: '+593 99 111 2222',
      weight: '68 kg',
      height: '1.68 m',
      bloodPressure: '118/76 mmHg',
      temperature: '36.7°C',
      pulse: '72',
      respiratoryRate: '16',
      pulseOximetry: '98',
      capillaryGlucose: '91',
      medicalHistory: 'Alergia a penicilina. Sin cirugías relevantes.',
      familyHistory: 'Madre con hipertensión arterial.',
      allergies: 'Penicilina',
      currentMedications: 'Loratadina 10 mg si presenta rinitis alergica.',
      disability: 'No',
      disabilityDetail: '',
      priorityGroup: 'Ninguno',
      emergencyRelationship: 'Madre',
    },
    {
      id: 'pat002',
      username: 'miguel',
      password: '1234',
      name: 'Miguel Torres',
      role: 'patient',
      documentId: '0923456789',
      clinicalHistoryNumber: 'HCU-0002',
      fileNumber: 'ARCH-002',
      email: 'miguel@clinic.com',
      phone: '+34 623 004 556',
      birthDate: '1982-11-28',
      sex: 'Masculino',
      insurance: 'Plan Empresarial',
      plan: 'Plan Empresarial',
      serviceActive: true,
      address: 'Cdla. Kennedy Norte Mz. 12, Guayaquil',
      city: 'Guayaquil',
      province: 'Guayas',
      emergencyContact: 'Elena Torres',
      emergencyPhone: '+593 99 333 4444',
      weight: '82 kg',
      height: '1.78 m',
      bloodPressure: '124/80 mmHg',
      temperature: '36.8°C',
      pulse: '78',
      respiratoryRate: '18',
      pulseOximetry: '96',
      capillaryGlucose: '103',
      medicalHistory: 'Antecedente de asma leve. Uso ocasional de inhalador.',
      familyHistory: 'Padre con diabetes mellitus tipo 2.',
      allergies: 'Niega alergias conocidas.',
      currentMedications: 'Salbutamol inhalador segun necesidad.',
      disability: 'No',
      disabilityDetail: '',
      priorityGroup: 'Ninguno',
      emergencyRelationship: 'Conyuge',
    },
    {
      id: 'pat003',
      username: 'carla',
      password: '1234',
      name: 'Carla Sánchez',
      role: 'patient',
      documentId: '0104567890',
      clinicalHistoryNumber: 'HCU-0003',
      fileNumber: 'ARCH-003',
      email: 'carla@clinic.com',
      phone: '+34 634 008 912',
      birthDate: '2001-02-08',
      sex: 'Femenino',
      insurance: 'Plan Profesional',
      plan: 'Plan Profesional',
      serviceActive: false,
      address: 'Calle Larga 8-55, Cuenca',
      city: 'Cuenca',
      province: 'Azuay',
      emergencyContact: 'Jorge Sánchez',
      emergencyPhone: '+593 99 555 6666',
      weight: '56 kg',
      height: '1.65 m',
      bloodPressure: '114/72 mmHg',
      temperature: '36.5°C',
      pulse: '70',
      respiratoryRate: '15',
      pulseOximetry: '99',
      capillaryGlucose: '88',
      medicalHistory: 'Sin antecedentes patológicos personales relevantes.',
      familyHistory: 'Sin antecedentes familiares relevantes referidos.',
      allergies: 'Niega alergias conocidas.',
      currentMedications: 'No refiere medicacion habitual.',
      disability: 'No',
      disabilityDetail: '',
      priorityGroup: 'Ninguno',
      emergencyRelationship: 'Padre',
    },
  ],
};

export const mockAppointments = [
  {
    id: 'apt001',
    doctorId: 'doc001',
    patientId: 'pat001',
    doctor: mockUsers.doctors[0],
    patient: mockUsers.patients[0],
    datetime: '2026-04-15T10:30:00',
    reason: 'Revisión médica general',
    status: 'pendiente',
  },
  {
    id: 'apt002',
    doctorId: 'doc002',
    patientId: 'pat002',
    doctor: mockUsers.doctors[1],
    patient: mockUsers.patients[1],
    datetime: '2026-04-15T11:30:00',
    reason: 'Seguimiento de síntomas respiratorios',
    status: 'pendiente',
  },
  {
    id: 'apt003',
    doctorId: 'doc003',
    patientId: 'pat003',
    doctor: mockUsers.doctors[2],
    patient: mockUsers.patients[2],
    datetime: '2026-04-15T12:30:00',
    reason: 'Consulta por dolor de espalda',
    status: 'pendiente',
  },
];

export const mockNotes = {
  'apt001': {
    patientHistory: 'Paciente sin antecedentes relevantes. Alergias: Penicilina.',
    consultation: 'Consulta por dolor de cabeza persistente',
    findings: 'Presión arterial: 120/80 mmHg. Frecuencia cardíaca: 72 bpm',
    recommendations: 'Reposo, hidratación, analgésico si es necesario',
  },
  'apt002': {
    patientHistory: 'Antecedentes de asma leve. Uso de inhalador ocasional.',
    consultation: 'Tos persistente y malestar general',
    findings: 'Saturación: 96%. Respiración con leves sibilancias.',
    recommendations: 'Controlar síntomas con nebulizaciones y seguimiento en 48h',
  },
};

export const cie10Catalog = [
  { code: 'A09', description: 'Diarrea y gastroenteritis de presunto origen infeccioso' },
  { code: 'B34.9', description: 'Infeccion viral, no especificada' },
  { code: 'E03.9', description: 'Hipotiroidismo, no especificado' },
  { code: 'E11.9', description: 'Diabetes mellitus tipo 2 sin complicaciones' },
  { code: 'F41.9', description: 'Trastorno de ansiedad, no especificado' },
  { code: 'G43.9', description: 'Migrana, no especificada' },
  { code: 'H10.9', description: 'Conjuntivitis, no especificada' },
  { code: 'I10', description: 'Hipertension esencial primaria' },
  { code: 'I20.9', description: 'Angina de pecho, no especificada' },
  { code: 'J00', description: 'Rinofaringitis aguda, resfriado comun' },
  { code: 'J02.9', description: 'Faringitis aguda, no especificada' },
  { code: 'J06.9', description: 'Infeccion aguda de las vias respiratorias superiores, no especificada' },
  { code: 'J20.9', description: 'Bronquitis aguda, no especificada' },
  { code: 'J45.9', description: 'Asma, no especificada' },
  { code: 'K21.9', description: 'Enfermedad del reflujo gastroesofagico sin esofagitis' },
  { code: 'K29.7', description: 'Gastritis, no especificada' },
  { code: 'L20.9', description: 'Dermatitis atopica, no especificada' },
  { code: 'M25.5', description: 'Dolor en articulacion' },
  { code: 'M54.5', description: 'Lumbago no especificado' },
  { code: 'M79.1', description: 'Mialgia' },
  { code: 'N39.0', description: 'Infeccion de vias urinarias, sitio no especificado' },
  { code: 'N76.0', description: 'Vaginitis aguda' },
  { code: 'O26.9', description: 'Complicacion relacionada con el embarazo, no especificada' },
  { code: 'R05', description: 'Tos' },
  { code: 'R10.4', description: 'Otros dolores abdominales y los no especificados' },
  { code: 'R42', description: 'Mareo y desvanecimiento' },
  { code: 'R50.9', description: 'Fiebre, no especificada' },
  { code: 'R51', description: 'Cefalea' },
  { code: 'R53', description: 'Malestar y fatiga' },
  { code: 'Z00.0', description: 'Examen medico general' },
  { code: 'Z71.9', description: 'Consulta, no especificada' },
];
